<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'
import { stringify } from 'querystring';
let type = "TRUCKS";

export default {
        init: (payload) => {
        console.log('######### INITI');
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
            
        setTimeout(async function(){
            let trucks = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {}, `${Endpoints.trucks.listByType}`));
            if (trucks.status==200){
                payload.items = trucks.data.results;
                payload.listCertifies = JSON.stringify(payload.items.certifies);
            }
        }, 100);
        },
        methods:{
        filter: function(){
            let payload = this;
            let trucks=null;
            if(this.filters.typeSearch !=""){
                if(this.filters.typeSearch == ("ALL")){
                    payload.items = [];
                    setTimeout(async function(){
                    trucks = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {manufacturer: payload.filters.manufacturer}, `${Endpoints.trucks.listByType}`));
                    if (trucks.status==200){
                        payload.items = trucks.data.results;
                    }
                    }, 100);
                }
                if(this.filters.typeSearch == ("TRUCK")){
                    payload.items = [];
                    setTimeout(async function(){
                    trucks = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),
                    {vehicleTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK","TRUCK_MECHANICAL_HORSE_SIMPLE",
                    "TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO","TRUCK_DOUBLE_TRAIN","TRUCK_RODOTREM"],manufacturer: payload.filters.manufacturer}, `${Endpoints.trucks.listByType}`));
                    if (trucks.status==200){
                        payload.items = trucks.data.results;
                    }
                    }, 100);

                }
                if(this.filters.typeSearch == ("TRUCK_TRAILER")){
                    payload.items = [];
                    setTimeout(async function(){
                    trucks = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),
                    {vehicleTypes:["TRUCKTRAILER_VANDERLEIA", "TRUCKTRAILER_CONVENCIONAL" ,"TRUCKTRAILER_DOLLY"],manufacturer: payload.filters.manufacturer}, 
                    `${Endpoints.trucks.listByType}`));
                    if (trucks.status==200){
                        payload.items = trucks.data.results;
                    }
                    }, 100);
                }
        
            }
            else
            {
                this.titleToast = this.$t('string.msg.warning');
                this.messageToast = this.$t('string.msg.filter.select.required');
                $('#toast').modal('show');
            }
        },
        onChange: function(vehicle){
            let payload = this;
            setTimeout(async function(){
            let respManufacturers = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type:vehicle}, `${Endpoints.parts.manufacturer.listByType}`)).data;
                    if (respManufacturers.status==200){
                        payload.manufacturers = respManufacturers.results;
                    }
            }, 100);

        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        fetchData(){
            let name=""
            this.json_data = this.items;
            console.log(this.json_data.length);
            for(let i=0; i<this.json_data.length;i++)
            {   
                    name = this.$t(this.json_data[i].vehicleType);
                    this.json_data[i].vehicleType = name.toUpperCase(); 
            }
            return this.json_data;
        },
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
